import React from 'react'

import { AlignItems, Box, Color, Display, Overflow } from '@gousto-internal/citrus-react'

import { FlexPortionSummary } from './FlexPortionSummary'

type FlexPortionTileBadgeProps = {
  recipeCount: number
  portionCount: number
  onEdit: () => void
}

export const FlexPortionTileBadge = ({
  recipeCount,
  portionCount,
  onEdit,
}: FlexPortionTileBadgeProps) => {
  return (
    <Box
      alignItems={AlignItems.Center}
      bg={Color.White}
      boxShadow="0 1px 5px 0 rgba(51, 61, 71, 0.2)"
      data-testid="flex-portion-tile-badge"
      display={Display.InlineFlex}
      maxWidth="100%"
      minHeight="44px"
      overflowX={Overflow.Hidden}
      overflowY={Overflow.Hidden}
      paddingH={3}
      paddingRight={0}
      style={{ borderRadius: '4px' }}
    >
      <FlexPortionSummary
        recipeCount={recipeCount}
        portionCount={portionCount}
        onEdit={onEdit}
        stopEventPropagation
      />
    </Box>
  )
}
